"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Button;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
require("./styles.scss");
var _material = require("@mui/material");
function Button(props) {
  const {
    onClick,
    label,
    type = 'productive',
    priority = 'primary',
    size = 'small',
    disabled,
    icon,
    rightIcon,
    processing,
    id,
    className,
    style,
    sx
  } = props;
  return /*#__PURE__*/_react.default.createElement(_material.ButtonBase, {
    id: id,
    onClick: onClick,
    className: "button ".concat(type, "-").concat(priority, " button--").concat(size, " ").concat(type, "-").concat(priority, "--").concat(size, " ").concat(icon && !processing ? 'button-with-icon' : '', " ").concat(rightIcon && !processing ? 'button-with-right-icon' : '', "\n      ").concat(!label ? 'button-no-label' : '', " ").concat(className !== null && className !== void 0 ? className : ''),
    disabled: disabled,
    style: style,
    sx: [{
      '& path': {
        fill: 'currentColor'
      }
    }, ...(Array.isArray(sx) ? sx : [sx])]
  }, processing && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "spinner",
    size: size,
    className: "icon-spinner"
  }), !processing && icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: icon,
    size: size
  }), !processing && !!label && label, !processing && rightIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: rightIcon,
    size: size,
    className: "icon-right"
  }));
}